import { playChime } from '@bn-games/audio-core';
import { chooseMove } from '../ai/AiPlayer.js';
import type { Settings } from '../settings/types.js';
import type { Square } from '../game/types.js';
import type { Match } from './Match.js';

const HINT_DURATION_MS = 4_000;

export interface AfkHint {
  readonly from: Square;
  readonly to: Square;
  readonly until: number;
}

/**
 * The player has idled on their turn: chime (if reminders are on) and, if
 * the hint is on, suggest a sensible move — the Easy bot's choice, which is
 * cheap and never a howler.
 */
export function afkHint(match: Match, settings: Settings): AfkHint | null {
  if (!match.canHumanMove()) return null;
  if (settings.afkRemindersEnabled) playChime();
  if (!settings.afkAssistEnabled) return null;
  const move = chooseMove(match.state.position, 'easy');
  return move === null ? null : { from: move.from, to: move.to, until: Date.now() + HINT_DURATION_MS };
}
